// extracted by mini-css-extract-plugin
module.exports = {"header":"i_Bh","body":"i_Bi","content":"i_Bj","image":"i_Bk"};